"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentTooltip = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n            border-width: 6px 5.5px 0 5.5px;\n            border-color: ", " transparent transparent\n              transparent;\n            top: 100%;\n          "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n            border-width: 0 5.5px 6px 5.5px;\n            border-color: transparent transparent ", "\n              transparent;\n            bottom: 100%;\n          "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            border-width: 6px 5.5px 0 5.5px;\n            border-color: ", " transparent transparent\n              transparent;\n            top: 100%;\n          "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n            border-width: 0 5.5px 6px 5.5px;\n            border-color: transparent transparent ", "\n              transparent;\n            bottom: 100%;\n          "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n              left: 10%;\n            "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n              right: 5%;\n            "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n            left: 50%;\n          "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          bottom: 100%;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          top: 100%;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n            left: 50%;\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            left: 100%;\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          right: 100%;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  z-index: 50;\n  ", "\n  background: ", ";\n  ", "\n  color: ", ";\n  ", "\n  border: 1px solid ", ";\n  ", "\n  box-shadow: 0 2px 10px 0 ", ";\n  border-radius: ", ";\n  width: max-content;\n  min-width: 90px;\n  max-width: 300px;\n  overflow-wrap: break-word;\n  text-align: ", ";\n  position: absolute;\n  padding: ", ";\n  line-height: normal;\n  font-size: 13px;\n  ", "\n  transform: translateX(", ");\n  margin: ", " 0;\n  pointer-events: none;\n  ", ";\n\n  &:after,\n  &:before {\n    content: '';\n    width: 0;\n    height: 0;\n    border-style: solid;\n    ", "\n    position: absolute;\n    margin-left: -5px;\n  }\n  &:after {\n    ", ";\n  }\n  &:before {\n    ", ";\n  }}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'tooltip');
};

var StyledTooltip = _styledComponents["default"].div(_templateObject(), ''
/* background: ${colors.tooltip.background}; */
, function (props) {
  return getColors(props).background;
}, ''
/* color: ${colors.tooltip.text}; */
, function (props) {
  return getColors(props).text;
}, ''
/* border: 1px solid ${colors.tooltip.border}; */
, function (props) {
  return getColors(props).border;
}, ''
/* box-shadow: 0 2px 10px 0 ${colors.tooltip.boxShadow}; */
, function (props) {
  return getColors(props).boxShadow;
}, _tokens.misc.radius, function (props) {
  return props.textAlign;
}, _tokens.spacing.xsmall, function (props) {
  return props.align === 'right' ? (0, _styledComponents.css)(_templateObject2()) : props.align === 'left' ? (0, _styledComponents.css)(_templateObject3()) : (0, _styledComponents.css)(_templateObject4());
}, function (props) {
  return props.align === 'left' ? '-100%' : props.align === 'right' ? '100%' : '-50%';
}, _tokens.spacing.xsmall, function (props) {
  return props.position === 'bottom' ? (0, _styledComponents.css)(_templateObject5()) : (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.align === 'middle' ? (0, _styledComponents.css)(_templateObject7()) : props.align === 'left' ? (0, _styledComponents.css)(_templateObject8()) : (0, _styledComponents.css)(_templateObject9());
}, function (props) {
  return props.position === 'bottom' ? (0, _styledComponents.css)(_templateObject10(), getColors(props).background) : (0, _styledComponents.css)(_templateObject11(), getColors(props).background);
}, function (props) {
  return props.position === 'bottom' ? (0, _styledComponents.css)(_templateObject12(), getColors(props).text) : (0, _styledComponents.css)(_templateObject13(), getColors(props).text);
});

var ContentTooltip = _styledComponents["default"].div(_templateObject14());

exports.ContentTooltip = ContentTooltip;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });

    _defineProperty(_assertThisInitialized(_this), "hide", function () {
      _this.setState({
        show: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "show", function () {
      _this.setState({
        show: true
      });
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          children = _this$props.children;
      return _react["default"].createElement(ContentTooltip, {
        content: content,
        onMouseLeave: this.hide,
        onMouseEnter: this.show
      }, this.state.show && content && _react["default"].createElement(StyledTooltip, this.props, content), children);
    }
  }]);

  return Tooltip;
}(_react["default"].Component);

Tooltip.propTypes = {
  /** Content to show in the tooltip */
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]).isRequired,

  /** Where to place the tooltip */
  position: _propTypes["default"].oneOf(['top', 'bottom']),

  /** How to align the tooltip */
  align: _propTypes["default"].oneOf(['left', 'middle', 'right']),

  /** How to align the content within the  tooltip */
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right'])
};
Tooltip.defaultProps = {
  content: null,
  position: 'top',
  align: 'middle',
  textAlign: 'center'
};
Tooltip.displayName = 'Tooltip';

var _default = (0, _context.withVersion)(Tooltip);

exports["default"] = _default;